import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
//import MeetingCalendar from "../components/calendar/MeetingCalendar";
//import Meeting from "../components/meeting/Meeting";
import { Routes, Route, useParams } from 'react-router-dom';
import Member from "../components/member/Member";
import Container from 'react-bootstrap/Container';
export default function MemberRoute() {

    //const [selectedMeeting, setSelectedMeeting] = useState(null);
    const onSelectMember = (eventitem) => {
        //setSelectedMeeting(eventitem.id);
    }
    const { id } = useParams();

    return (
        <>
            <Container>
                {id != null ?
                    (<Member id={id}></Member>)
                    :
                    (<div>No Member Found
                        {id}</div>)
                }
            </Container>
        </>
    );
}